import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsTable } from "react-icons/bs";
import html2pdf from "html2pdf.js";
import moment from "moment";
import HBLLogo from "../../assets/image.png"
import { getFundByAmc } from "../../stores/services/funds.service";
import Select from "react-select";
import ReportHeaderCard from "./ReportHeaderSection/ReportHeader";
import { PDFExport } from "@progress/kendo-react-pdf";
import { useTheme } from "../../contexts/ThemeContext";
import useCustomStyles from "../../hooks/useCustomStyles";
import { getAmc } from "../../stores/services/amc.service";
import { numberWithCommas } from "../../utils/customFunction";

function PFFundSummaryReport() {
    const { theme } = useTheme();
    const { customStyles } = useCustomStyles();
    const amcCode = sessionStorage.getItem('amc_code') || '';

    const email = sessionStorage.getItem("email") || "";
    const pdfExportComponent = React.useRef<PDFExport>(null);
    const amc_code = sessionStorage.getItem("amc_code") || "";
    const [fromDate, setFromDate] = useState<any>(moment().format("YYYY-MM"));
    const [toDate, setToDate] = useState<any>(moment().format("YYYY-MM"));
    const [loading, setLoading] = useState(false);
    const [pfFundsData, setPfFundsData] = useState([]);
    const [fund, setFund] = useState("");
    const [fundLoading, setFundLoading] = useState<boolean>(false);
    const [allFunds, setAllFunds] = useState<any>([]);
    const [searchCode, setSearchCode] = useState<any>("");
    const [searchName, setSearchName] = useState<any>("");
    const [amcName, setAmcName] = useState("");
    const [amcdata, setAmcdata] = useState<any>([]);
    const [summary, setSummary] = useState<any>({
        totalEmployeeContribution: 0,
        totalEmployerContribution: 0,
        totalProfit: 0,
        grandTotal: 0
    });
    const getfundByAmcCode = async (code: string, fund_type?: string) => {
        allFunds.length = 0;
        setAllFunds(allFunds);
        //get funds by amc for dropdown
        try {
            const response = await getFundByAmc(
                email,
                code,
                fund_type ? { fund_type } : undefined
            );
            setAllFunds(response.data.data);
            if (response.data.data.length > 0) {
                setFundLoading(false);
            } else {
                setFundLoading(true);
            }
        } catch (err: any) {
            if (err.response !== undefined) {
                toast.error(err.response.data.message);
            } else {
                toast.error(err.message);
            }
        }
    };
    React.useEffect(() => {
        getfundByAmcCode(amcCode);
    }, [])


    // Load data from localStorage
    const loadPfFundsData = (isSearch = "") => {
        try {
            setLoading(true);
            const storedData = localStorage.getItem("pf_funds");
            if (storedData) {
                const fromDateMoment = moment(fromDate, "YYYY-MM");
                const toDateMoment = moment(toDate, "YYYY-MM");

                const parsedData = isSearch
                    ? JSON.parse(storedData)?.filter(ele => {
                        const dataMoment = moment(ele?.Month, 'M/D/YY');

                        if (!dataMoment.isValid() || !fromDateMoment.isValid() || !toDateMoment.isValid()) {
                            return false;
                        }

                        return dataMoment.isBetween(fromDateMoment, toDateMoment, 'month', '[]');
                    })
                    : JSON.parse(storedData);

                let tempData = parsedData?.filter((ele) => ele["Fund Code"] === fund && (ele["Employee Code"] === searchCode || ele["Employee Name"]?.toLowerCase()?.includes(searchName?.toLowerCase())))
                if (tempData?.length === 0) {
                    toast.error("No record found!")
                }
                setPfFundsData(tempData);
                const totalEmployeeContribution = tempData.reduce((sum, item) =>
                    sum + parseFloat(item["Employee Contribution"]?.replace(/,/g, '') || 0), 0);
                const totalEmployerContribution = tempData.reduce((sum, item) =>
                    sum + parseFloat(item["Employer Contribution"]?.replace(/,/g, '') || 0), 0);
                const totalProfit = tempData.reduce((sum, item) =>
                    sum + parseFloat(item["Profit"]?.replace(/,/g, '') || 0), 0);
                const grandTotal = tempData.reduce((sum, item) =>
                    sum + parseFloat(item["Total"]?.replace(/,/g, '') || 0), 0);

                setSummary({
                    totalEmployeeContribution,
                    totalEmployerContribution,
                    totalProfit,
                    grandTotal
                });
            } else {
                toast.error("No record found!")
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error("Error loading PF Funds data");
        }
    };

    const renderFundsDropdown = () => {
        let temp: any = []
        temp = allFunds.map((item: any, index: string) => {
            if (item.nature === "Special Managed Account") {
                return {
                    value: item.symbol_code,
                    label: `${item.fund_name} (${item.symbol_code}) - SMA`,
                };
            } else {
                return {
                    value: item.symbol_code,
                    label: `${item.fund_name} (${item.symbol_code})`,
                };
            }
        });
        return temp
    };

    const selectedFundName = React.useMemo(() => {
        const selectedFund = allFunds.find((item) => item?.symbol_code === fund);
        return selectedFund && selectedFund.nature === "Special Managed Account"
            ? {
                value: selectedFund.symbol_code,
                label: `${selectedFund.fund_name} (${selectedFund.symbol_code}) - SMA`,
            }
            : selectedFund
                ? {
                    value: selectedFund.symbol_code,
                    label: `${selectedFund.fund_name} (${selectedFund.symbol_code})`,
                }
                : null;
    }, [allFunds, fund]);

    return (
        <>
            <div className="content">
                <Row>
                    <Col md="12">
                        <Container fluid>
                            <ToastContainer limit={1} />
                            <div className="">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-title">Provident Fund Account Summary</h4>
                                    </div>
                                    <div className="card-body">
                                        <Row className="align-items-center">
                                            <Col md="3" xs="12" className="mb-3 mb-md-0">
                                                <div className="form-group">
                                                    <label>
                                                        Fund
                                                    </label>
                                                    {fundLoading ? (
                                                        <div className="form-control w-100">
                                                            <i className="fa fa-spinner fa-spin fa-1x"></i>
                                                        </div>
                                                    ) : (
                                                        <Select
                                                            disabled={false}
                                                            value={selectedFundName}
                                                            label={fundLoading ? "Loading..." : "Select Fund"}
                                                            onChange={(e) => {
                                                                setFund(e?.value);
                                                            }}
                                                            menuPortalTarget={document.body}
                                                            menuShouldBlockScroll={true}
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            name="color"
                                                            options={renderFundsDropdown()}
                                                            styles={customStyles}
                                                        />
                                                    )}
                                                </div>
                                            </Col>

                                            <Col md="3" xs="12" className="mb-3 mb-md-0">
                                                <div className="form-group">
                                                    <label htmlFor="pf-date">From Year</label>
                                                    <input
                                                        style={{
                                                            colorScheme: theme === "light" ? "light" : "dark",
                                                        }}
                                                        type="month"
                                                        className="form-control py-1"
                                                        value={fromDate}
                                                        onChange={(e) => {
                                                            setPfFundsData([]);
                                                            setFromDate(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                            </Col>

                                            <Col md="3" xs="12" className="mb-3 mb-md-0">
                                                <div className="form-group">
                                                    <label htmlFor="pf-date">To Year</label>
                                                    <input
                                                        style={{
                                                            colorScheme: theme === "light" ? "light" : "dark",
                                                        }}
                                                        type="month"
                                                        className="form-control py-1"
                                                        value={toDate}
                                                        onChange={(e) => {
                                                            setPfFundsData([]);
                                                            setToDate(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                            </Col>

                                            <Col md="3" xs="12" className="mb-3 mb-md-0">
                                                <div className="form-group">
                                                    <label htmlFor="pf-date">Employee Code</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={searchCode}
                                                        onChange={(e) => {
                                                            setPfFundsData([]);
                                                            setSearchCode(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                            </Col>
                                            <Col md="3" xs="12" className="mb-3 mb-md-0">
                                                <div className="form-group">
                                                    <label htmlFor="pf-date">Employee Name</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        value={searchName}
                                                        onChange={(e) => {
                                                            setPfFundsData([]);
                                                            setSearchName(e.target.value);
                                                        }}
                                                    />
                                                </div>
                                            </Col>

                                            <Col md="auto" xs="6" className="d-flex align-items-end mt-3 mb-md-0">
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={() => {
                                                        if (fund == "" || fund == undefined) {
                                                            toast.error("Fund should not be empty")
                                                            return
                                                        }
                                                        else if (!searchCode && !searchName) {
                                                            toast.error("Employee Code or Name should not be empty")
                                                            return
                                                        }
                                                        else {
                                                            loadPfFundsData("search");
                                                        }

                                                    }}
                                                    disabled={Boolean(loading)}
                                                >
                                                    {loading ? (
                                                        <>
                                                            <span
                                                                className="spinner-border login-txt spinner-border-sm"
                                                                role="status"
                                                                aria-hidden="true"
                                                            ></span>
                                                            <span className="login-txt"> Loading...</span>
                                                        </>
                                                    ) : (
                                                        <span>Search</span>
                                                    )}
                                                </button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>

                                <div className="card mt-3">
                                    <div className="card-body">
                                        <div
                                            id="printDiv"
                                            className="p-4"
                                            style={{ background: "white", color: "black" }}
                                        >
                                            <PDFExport
                                                paperSize="A4"
                                                margin="1.5cm"
                                                scale={0.6}
                                                landscape={true}
                                                repeatHeaders={true}
                                                fileName={"PFFund-Statement.pdf"}
                                                ref={pdfExportComponent}
                                            >
                                                {pfFundsData.length > 0 ? (
                                                    <>
                                                        <div className="row align-items-center">
                                                            <div className="col-4 d-flex justify-content-start">
                                                                <img
                                                                    src={HBLLogo}
                                                                    alt="Vertices-Logo"
                                                                    style={{
                                                                        width: "auto",
                                                                        height: "27px",
                                                                    }}
                                                                />
                                                            </div>
                                                            <div className="col-4 d-flex flex-column align-items-center justify-content-center">
                                                                <h6 className="text-black mt-2 mb-0">Provident Fund Report</h6>
                                                            </div>
                                                        </div>
                                                        {/* <ReportHeader title="Provident Fund Report" /> */}
                                                        <ReportHeaderCard
                                                            unitholderDetails={summary}
                                                            allDetails={pfFundsData}
                                                            reportName={"PFFundSummary"}
                                                            report={true}
                                                        />
                                                        <div>
                                                            <table
                                                                className="report"
                                                                style={{
                                                                    color: "black",
                                                                    width: "100%",
                                                                    borderCollapse: "collapse",
                                                                    tableLayout: "fixed"
                                                                }}
                                                            >
                                                                <thead>
                                                                    <tr
                                                                        style={{
                                                                            borderTop: "2px solid black",
                                                                            borderBottom: "2px solid black",
                                                                        }}
                                                                    >
                                                                        <th

                                                                            style={{
                                                                                width: "10%",
                                                                                textAlign: "left",
                                                                                padding: "8px 4px",
                                                                            }}
                                                                        >
                                                                            Fund Code
                                                                        </th>

                                                                        <th

                                                                            style={{
                                                                                width: "10%",
                                                                                textAlign: "left",
                                                                                padding: "8px 4px",
                                                                            }}
                                                                        >
                                                                            Month
                                                                        </th>

                                                                        <th

                                                                            style={{
                                                                                width: "12%",
                                                                                textAlign: "right",
                                                                                padding: "8px 4px",
                                                                            }}
                                                                        >
                                                                            Employee Contribution
                                                                        </th>

                                                                        <th

                                                                            style={{
                                                                                width: "12%",
                                                                                textAlign: "right",
                                                                                padding: "8px 4px",
                                                                            }}
                                                                        >
                                                                            Employer Contribution
                                                                        </th>

                                                                        <th

                                                                            style={{
                                                                                width: "10%",
                                                                                textAlign: "right",
                                                                                padding: "8px 4px",
                                                                            }}
                                                                        >
                                                                            Profit
                                                                        </th>

                                                                        <th

                                                                            style={{
                                                                                width: "10%",
                                                                                textAlign: "right",
                                                                                padding: "8px 4px",
                                                                            }}
                                                                        >
                                                                            Total
                                                                        </th>

                                                                        <th

                                                                            style={{
                                                                                width: "11%",
                                                                                textAlign: "left",
                                                                                padding: "8px 4px",
                                                                            }}
                                                                        >
                                                                            Remarks
                                                                        </th>

                                                                    </tr>
                                                                </thead>
                                                                <tbody className="report-table-body">
                                                                    {pfFundsData.map((item: any, index) => (
                                                                        <tr key={index}>

                                                                            <td
                                                                                style={{
                                                                                    width: "10%",
                                                                                }}

                                                                            >
                                                                                {item["Fund Code"]}
                                                                            </td>
                                                                            <td
                                                                                style={{
                                                                                    width: "10%",
                                                                                }}

                                                                            >
                                                                                {moment(item?.Month)?.format("MMM, YYYY")}
                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    width: "12%",
                                                                                }}

                                                                                className="text-right"
                                                                            >
                                                                                {numberWithCommas(parseFloat(item["Employee Contribution"]?.replaceAll(",", "") || 0)?.toFixed(2))}
                                                                                {/* {item["Employee Contribution"]} */}
                                                                                {/* <CardColComponent
                                                  subTitle={item["Employee Contribution"]}
                                                  amount={true}
                                                  simple={true}
                                                /> */}
                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    width: "12%",
                                                                                }}

                                                                                className="text-right"
                                                                            >
                                                                                {numberWithCommas(parseFloat(item["Employer Contribution"]?.replaceAll(",", "") || 0)?.toFixed(2))}
                                                                                {/* {item["Employer Contribution"]} */}
                                                                                {/* <CardColComponent
                                                  subTitle={item["Employer Contribution"]}
                                                  amount={true}
                                                  simple={true}
                                                /> */}
                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    width: "10%",
                                                                                }}

                                                                                className="text-right"
                                                                            >
                                                                                {numberWithCommas(parseFloat(item?.Profit?.replaceAll(",", "") || 0)?.toFixed(2))}
                                                                                {/* <CardColComponent
                                                  subTitle={item.Profit}
                                                  amount={true}
                                                  simple={true}
                                                /> */}
                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    width: "10%",
                                                                                }}

                                                                                className="text-right"
                                                                            >
                                                                                {numberWithCommas(parseFloat(item?.Total?.replaceAll(",", "") || 0)?.toFixed(2))}
                                                                                {/* <CardColComponent
                                                  subTitle={item.Total}
                                                  amount={true}
                                                  simple={true}
                                                /> */}
                                                                            </td>

                                                                            <td
                                                                                style={{
                                                                                    width: "11%",
                                                                                }}

                                                                                className="text-left"
                                                                            >
                                                                                {item?.Remarks}
                                                                            </td>

                                                                        </tr>
                                                                    ))}
                                                                </tbody>

                                                                {/* Summary Footer */}
                                                                <tfoot>
                                                                    <tr style={{ borderTop: "2px solid black" }}>

                                                                        <th

                                                                            style={{
                                                                                width: "10%",
                                                                                textAlign: "left",
                                                                                padding: "8px 4px",
                                                                                fontWeight: "bold",
                                                                            }}
                                                                        >
                                                                            Total
                                                                        </th>

                                                                        <th

                                                                            style={{
                                                                                width: "10%",
                                                                                textAlign: "left",
                                                                                padding: "8px 4px",
                                                                                fontWeight: "bold",
                                                                            }}
                                                                        >

                                                                        </th>

                                                                        <th

                                                                            style={{
                                                                                width: "12%",
                                                                                textAlign: "right",
                                                                                padding: "8px 4px",
                                                                            }}
                                                                        >
                                                                            {numberWithCommas(parseFloat(summary.totalEmployeeContribution || 0).toFixed(2))}
                                                                            {/* <CardColComponent
                                                subTitle={numberWithCommas(summary.totalEmployeeContribution.toFixed(2))}
                                                amount={true}
                                                simple={true}
                                              /> */}
                                                                        </th>

                                                                        <th

                                                                            style={{
                                                                                width: "12%",
                                                                                textAlign: "right",
                                                                                padding: "8px 4px",
                                                                            }}
                                                                        >
                                                                            {numberWithCommas(parseFloat(summary?.totalEmployerContribution || 0)?.toFixed(2))}
                                                                            {/* <CardColComponent
                                                subTitle={numberWithCommas(summary.totalEmployerContribution.toFixed(2))}
                                                amount={true}
                                                simple={true}
                                              /> */}
                                                                        </th>

                                                                        <th

                                                                            style={{
                                                                                width: "10%",
                                                                                textAlign: "right",
                                                                                padding: "8px 4px",
                                                                            }}
                                                                        >
                                                                            {numberWithCommas(parseFloat(summary?.totalProfit)?.toFixed(2))}
                                                                            {/* <CardColComponent
                                                subTitle={numberWithCommas(summary.totalProfit.toFixed(2))}
                                                amount={true}
                                                simple={true}
                                              /> */}
                                                                        </th>

                                                                        <th

                                                                            style={{
                                                                                width: "10%",
                                                                                textAlign: "right",
                                                                                padding: "8px 4px",
                                                                            }}
                                                                        >
                                                                            {numberWithCommas(parseFloat(summary?.grandTotal || 0)?.toFixed(2))}
                                                                            {/* <CardColComponent
                                                subTitle={numberWithCommas(summary.grandTotal.toFixed(2))}
                                                amount={true}
                                                simple={true}
                                              /> */}
                                                                        </th>

                                                                        <th

                                                                            style={{
                                                                                width: "11%",
                                                                                padding: "8px 4px",
                                                                            }}
                                                                        ></th>
                                                                    </tr>
                                                                </tfoot>
                                                            </table>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <div className="table-empty">
                                                        <BsTable className="icon" />
                                                        <p className="text-center text-primary empty-text">
                                                            No PF Funds data found.
                                                        </p>
                                                    </div>
                                                )}
                                            </PDFExport>
                                        </div>
                                        <button
                                            className="btn btn-primary mt-3"
                                            onClick={() => {
                                                // printReport();
                                                if (pdfExportComponent.current) {
                                                    pdfExportComponent.current.save();
                                                }
                                            }}
                                        >
                                            Print
                                        </button>


                                    </div>
                                </div>
                            </div>
                        </Container>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default PFFundSummaryReport